import { render, staticRenderFns } from "./ServiceFieldsEditor.vue?vue&type=template&id=ce4fb93e"
import script from "./ServiceFieldsEditor.vue?vue&type=script&lang=js"
export * from "./ServiceFieldsEditor.vue?vue&type=script&lang=js"
import style0 from "./ServiceFieldsEditor.vue?vue&type=style&index=0&id=ce4fb93e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports